import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { OnboardingStep } from '../models';
import { Coverage3dOnboardingDeviceBehaviorService } from '../services';

@Pipe({
	name: 'onboardingStepTitle',
	standalone: true
})
export class OnboardingStepTitlePipe implements PipeTransform {
	private readonly transloco = inject(TranslocoService);
	private readonly deviceBehavior = inject(Coverage3dOnboardingDeviceBehaviorService);

	public transform(step: OnboardingStep, model: DeviceModel): string {
		// Prioritize the device-specific title if available
		const title = this.deviceBehavior.getStepTitle(model, step);
		if (title) {
			return title;
		}
		// Apply default titles based on the step if no device-specific title is available
		switch (step) {
			case OnboardingStep.SceneClickAndDrag:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.scene-click-and-drag.title');
			case OnboardingStep.LobeAdd:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-add.title');
			case OnboardingStep.LobeClickAndDrag:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-click-and-drag.title');
			case OnboardingStep.LobeMultiSelect:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-multi-select.title');
			case OnboardingStep.LobeSnap:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-steps.lobe-snap.title');
			default:
				return step ?? '';
		}
	}
}
